import axios from "axios";
import { IOfferedReserveData, OfertaAlumnoResponse } from "../types";
import { axiosInstances } from "../components/AxiosManager/AxiosInstances";
import { getAxiosInstanceOferta } from "./reservation";
import { CoreSeccionOferta } from "../types/oferta";

export const getMateriasAlumno = async (
  idPersona: string
): Promise<{ 
  data: OfertaAlumnoResponse["oferta"]; 
  status: number; 
  invalidando: boolean; 
  venciendo: boolean; 
}> => {
  const idAP = localStorage.getItem("idAP");
  const { data, status } = await getAxiosInstanceOferta(Number(idAP || idPersona)).post(`/api/materias?r=${Math.random().toString()}`, { idPersona });
  const response: OfertaAlumnoResponse = data;
  const { invalidando, venciendo } = response;
  
  if (invalidando) {
    console.log("%cOFERTA INVALIDADA", "color: DarkGreen; text-decoration: underline; background: PaleGreen;");
  }
  
  setTimeout(() => {
    if (venciendo) {
      console.log(
        "%cOFERTA VENCIDA, REGENERACIÓN EN PROCESO... ⏳",
        "color: DarkGreen; text-decoration: underline; background: PaleGreen;"
      );
    }
  }, 3000);
  
  return { 
    data: response.oferta, 
    status, 
    invalidando: invalidando || false, 
    venciendo: venciendo || false 
  };
};

export const getMateriasInscriptasAlumno = async (idPersona: number) => {
  try {
  const { data, status } = await axiosInstances.inscritas.post(`/api/materiasInscriptas?r=${Math.random().toString()}`, {
      id: idPersona,
    });
    return { data, status };
  } catch (error) {
    return { data: null, status: 401 };
  }
};

export const getMateriasFijadasAlumno = async (idPersona: number, token?: string) => {
  const config = token ? {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    }
  } : {};
  
  const { data, status } = await axiosInstances.fijadas.post(`/api/materiasFijadas?r=${Math.random().toString()}`, {
    id: idPersona,
  }, config);
  return { data, status };
};

export const toggleMateriaFijadaAlumno = async (idPersona: number, cursoId: number, anioLectivo: number) => {
  const { data, status } = await axiosInstances.fijadas.post(`/api/toggleMateriasFijadas?r=${Math.random().toString()}`, {
    id: idPersona,
    idCurso: cursoId,
    anioLectivo: anioLectivo,
  });
  return { data, status };
};

interface ICatalogoCondicionAprobCursoResponse {
  catalogo: string | null;
  condicionAprob: string | null;
  link: string | null;
}

export const getCatalogoCondicionAprobCurso = async (idCurso: number, anioLectivo: number): Promise<{ data: ICatalogoCondicionAprobCursoResponse; status: number }> => {
  const { data, status } = await axiosInstances.oferta.post(`/api/cursoCatalogoCondicion?r=${Math.random().toString()}`, {
    idCurso,
    anioLectivo,
  });
  return { data, status };
};

export const getCurso = async (idCurso: number, anioLectivo: number): Promise<{ data: CoreSeccionOferta; status: number }> => {
  const { data, status } = await axiosInstances.oferta.post(`/api/getCurso?r=${Math.random().toString()}`, {
    idCurso,
    anioLectivo,
  });
  return { data, status };
};